import { Link } from 'react-router-dom';
import './OrderCancel.css';

function OrderCancel() {
  return (
    <div className="order-cancel-page">
      <div className="cancel-container">
        <div className="cancel-icon" aria-hidden="true"><i className="fa-solid fa-circle-xmark" aria-hidden="true" /></div>
        <h1>Payment Cancelled</h1>
        <p>Your payment was cancelled. No charges were made.</p>

        <div className="cancel-actions">
          <Link to="/order" className="btn btn-primary">
            Try Again
          </Link>
          <Link to="/" className="btn btn-secondary">
            Return Home
          </Link>
        </div>
      </div>
    </div>
  );
}

export default OrderCancel;


